import React, { useEffect, useRef, useState } from 'react';
import './trust.css';

const testimonials = [
  {
    quote: "We've reduced oversight time by 80% with their autonomous neural optimization.",
    author: "Sarah Chen",
    role: "Head of AI at ScaleFlow"
  },
  {
    quote: "The speed of deployment is staggering. Our first agent was live in under 10 minutes.",
    author: "Alex Rivers",
    role: "CTO at Nexus AI"
  },
  {
    quote: "Finally, an AI agent system that understands context. It's like having a digital twin for operations.",
    author: "Marcus Thorne",
    role: "Director of Ops at Orbit Labs"
  },
  {
    quote: "Security was our biggest concern. The Sentinel integration makes this the only choice for enterprise.",
    author: "Elena Vance",
    role: "Security architect at Sentinel"
  },
  {
    quote: "Building multi-step workflows used to take weeks. Now it happens in real-time conversations.",
    author: "David Kim",
    role: "Product Lead at FlowState"
  },
  {
    quote: "The sub-100ms latency is not a promise, it's a reality. Incredible global performance.",
    author: "James Miller",
    role: "Infrastructure at CloudEdge"
  }
];

const Trust = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  // Divide testimonials into two groups for two side-by-side columns
  const firstCol = testimonials.slice(0, 3);
  const secondCol = testimonials.slice(3, 6);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const renderMarqueeGroup = (items) => (
    <div className="marquee-group">
      {[...items, ...items].map((t, index) => (
        <div key={index} className="testimonial-card">
          <div className="testimonial-quote">"{t.quote}"</div>
          <div className="testimonial-author">
            <div className="author-avatar-placeholder"></div>
            <div className="author-info">
              <div className="author-name">{t.author}</div>
              <div className="author-role">{t.role}</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <section className="trust-section" id="testimonials" ref={sectionRef}>
      <div className="trust-header">
        <h2 className="trust-title">Trusted by industry leaders</h2>
        <p className="trust-subtitle">Top organizations leverage our autonomous agents to scale operations and optimize performance.</p>
      </div>

      {/* Infinite Vertical Marquee */}
      <div className={`marquee-window ${isVisible ? 'is-visible' : ''}`}>
        <div className="marquee-mask top"></div>
        <div className="marquee-columns">
          <div className="marquee-column column-1">
            {renderMarqueeGroup(firstCol)}
          </div>
          <div className="marquee-column column-2">
            {renderMarqueeGroup(secondCol)}
          </div>
        </div>
        <div className="marquee-mask bottom"></div>
      </div>
    </section>
  );
};

export default Trust;
